import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

const PinVerification = React.lazy(() => import('./pages/PinVerification'));
const PinPaymentVerification = React.lazy(() => import('./pages/PinPaymentVerification'));
const PinRegistration = React.lazy(() => import('./pages/PinRegistration'));
const PinVerificationGeneral = React.lazy(() => import('./pages/v1.0/PinVerification'));

const App = () => (
  <Routes>
    <Route
      path="/partner/binding/pin-verification"
      element={
        <React.Suspense fallback={<>Loading...</>}>
          <PinVerification />
        </React.Suspense>
      }
    />
    <Route
      path="/partner/creation/pin-registration"
      element={
        <React.Suspense fallback={<>Loading...</>}>
          <PinRegistration />
        </React.Suspense>
      }
    />
    <Route
      path="/partner/payment/pin-verification"
      element={
        <React.Suspense fallback={<>Loading...</>}>
          <PinPaymentVerification />
        </React.Suspense>
      }
    />
    <Route
      path="/partner/pin/verification"
      element={
        <React.Suspense fallback={<>Loading...</>}>
          <PinVerificationGeneral />
        </React.Suspense>
      }
    />
    <Route path="/test" element={<p>{process.env.REACT_APP_API_STG_HOST}</p>} />
    <Route
      path="*"
      element={<p style={{ textAlign: 'center', marginTop: 50, fontSize: 24 }}>Page Not Found</p>}
    />
  </Routes>
);

export default App;
